import { buildGoalSections } from '@griply/utils';
import { useGoals } from 'features/goals';
import { useLocalizedLifeAreas } from 'features/life-areas';
import { useMemo } from 'react';
import { useUser } from 'shared/hooks/use-user';

export const useGoalSections = () => {
  const user = useUser();
  const goals = useGoals();
  const lifeAreas = useLocalizedLifeAreas();

  return useMemo(
    () =>
      buildGoalSections({
        goals,
        lifeAreas,
        goalSortingMode: user?.settings?.goalSortingMode,
        goalRoadmapSorting: user?.settings?.goalRoadmapSorting,
        goalGroupBy: user?.settings?.goalGroupBy,
        goalGroupSorting: user?.settings?.goalGroupSorting,
        lifeAreaSorting: user?.settings?.lifeAreaSorting,
      }),
    [
      goals,
      lifeAreas,
      user?.settings?.goalGroupBy,
      user?.settings?.goalGroupSorting,
      user?.settings?.goalRoadmapSorting,
      user?.settings?.goalSortingMode,
      user?.settings?.lifeAreaSorting,
    ],
  );
};
